module.exports = __webpack_public_path__ + "static/media/supernova.363cfe26.png";